import { useEffect } from 'react';

import { Helmet } from '@xing-com/crate-helmet';

import { useDisplayAdTracking, useDisplayAds } from './hooks';

type BiddingScriptTypes = {
  trackingParams: {
    page: string;
    sentBy: string;
  };
};

export const DisplayAdsBiddingScript: React.FC<BiddingScriptTypes> = ({
  trackingParams,
}) => {
  const { sentBy, page } = trackingParams;
  const { onViewableListener } = useDisplayAdTracking({ sentBy, page });
  const { displayAdsAllowed } = useDisplayAds();

  useEffect(() => {
    // @ts-expect-error yieldlove_cmd is defined by header bidding script
    window.yieldlove_cmd = window.yieldlove_cmd || [];
    window.googletag = window.googletag || { cmd: [] };

    googletag.cmd.push(() => {
      googletag.pubads().disableInitialLoad();
      googletag.enableServices();
      googletag
        .pubads()
        .addEventListener('impressionViewable', onViewableListener);
    });

    return () => {
      googletag.cmd.push(() => {
        googletag
          .pubads()
          .removeEventListener('impressionViewable', onViewableListener);
      });
    };
  }, [onViewableListener]);

  if (displayAdsAllowed) {
    return (
      <Helmet>
        <script
          async
          src="https://cdn-a.yieldlove.com/v2/yieldlove.js?xing.com"
        ></script>
        <script
          async
          src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
        ></script>
      </Helmet>
    );
  }

  return null;
};
